import { Btn, inputCls } from "./ui";

function Num({ label, value, onChange, testid }) {
  return (
    <label className="block text-[10px] text-slate-500">{label}
      <input type="number" data-testid={testid} className={`${inputCls} mono py-1 text-xs`} value={value} onChange={(e) => onChange(Number(e.target.value))} />
    </label>
  );
}

export default function RegionInspector({ region, onChange, onDelete }) {
  if (!region) return <div className="text-xs text-slate-500">Click a box on the artwork to edit it. Drag to move, pull the corner to resize.</div>;
  const set = (k) => (v) => onChange({ ...region, [k]: v });
  return (
    <div className="space-y-2" data-testid="artifact-region-inspector">
      <div className="flex items-center justify-between">
        <span className="mono text-xs text-slate-200">{region.id} <span className="text-slate-500">({region.kind}{region.quad ? ", 4-corner warp" : ""})</span></span>
        {region.kind === "text" && <Btn variant="danger" onClick={onDelete} data-testid="artifact-region-delete">Remove</Btn>}
      </div>
      {!region.quad && (
        <div className="grid grid-cols-4 gap-1.5">
          {["x", "y", "w", "h"].map((k) => <Num key={k} label={k} value={region[k]} onChange={set(k)} testid={`artifact-field-${k}`} />)}
        </div>
      )}
      {region.quad && (
        <div className="grid grid-cols-2 gap-1.5">
          {region.quad.map((p, i) => (
            <div key={i} className="text-[10px] text-slate-500">{["top-left", "top-right", "bottom-right", "bottom-left"][i]}
              <div className="mono text-xs text-slate-300">{p[0]}, {p[1]}</div>
            </div>
          ))}
        </div>
      )}
      {region.kind === "photo" && (
        <label className="block text-[10px] text-slate-500">Photo treatment
          <select data-testid="artifact-photo-treatment" className={`${inputCls} py-1 text-xs`} value={region.treatment} onChange={(e) => set("treatment")(e.target.value)}>
            <option value="mono">Grayscale + grain</option><option value="color">Full colour</option>
          </select>
        </label>
      )}
      {region.kind === "face_panel" && (
        <label className="block text-[10px] text-slate-500">Wireframe mesh side
          <select data-testid="artifact-replica-side" className={`${inputCls} py-1 text-xs`} value={region.replica_side || "image_right"} onChange={(e) => set("replica_side")(e.target.value)}>
            <option value="image_right">Viewer's right half</option><option value="image_left">Viewer's left half</option>
          </select>
        </label>
      )}
      {["hex_column", "data_block", "message"].includes(region.kind) && (
        <div className="text-[10px] text-slate-500">Words for this block are under Wording below.</div>
      )}
      {region.kind === "text" && (
        <>
          <label className="block text-[10px] text-slate-500">Text (variables allowed)
            <input data-testid="artifact-text-content" className={`${inputCls} mono py-1 text-xs`} value={region.text} onChange={(e) => set("text")(e.target.value)} />
          </label>
          <div className="grid grid-cols-3 gap-1.5">
            <Num label="font size" value={region.size} onChange={set("size")} testid="artifact-text-size" />
            <label className="block text-[10px] text-slate-500">colour
              <input type="color" data-testid="artifact-text-color" className="h-8 w-full rounded border border-[#243144] bg-transparent" value={region.color} onChange={(e) => set("color")(e.target.value)} />
            </label>
            <label className="block text-[10px] text-slate-500">align
              <select data-testid="artifact-text-align" className={`${inputCls} py-1 text-xs`} value={region.align} onChange={(e) => set("align")(e.target.value)}>
                <option>left</option><option>center</option><option>right</option>
              </select>
            </label>
          </div>
          <label className="flex items-center gap-2 text-xs"><input type="checkbox" data-testid="artifact-text-bold" checked={!!region.bold} onChange={(e) => set("bold")(e.target.checked)} /> bold</label>
        </>
      )}
    </div>
  );
}
